<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal3" :class="type == 2 ? 'modal-mask' : 'modal-mask1'" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal_reps_to_review d-none-">
                <div class="row mb-2 mt-0">
                  <div class="col-6 pl-4">
                    <div class="text-uppercase font-weight-bold">Add Other Skills</div>
                  </div>
                  <div class="col-6 pr-4 text-right"></div>              
                </div>

                <div class="col">
                  <div class="row mb-0 mt-3" style="margin-bottom: 10px;">
                    <div class="col-8 pl-2 pl-xl-4">

                      <b-form-select class="col-12 ma-input-field" v-model="taskListId" name="taskListId" :options="tasklist_options" placeholder="Select TaskList" v-validate="'required'" >           
                      </b-form-select>


                    </div>
                  </div>
                  <div class="row align-items-end mb-4">
                    <div class="col-5 px-2 px-xl-4">
                      <div class="validate-warning-msg text-left" v-if="verrors.first('taskListId')">Tasklist is required</div>
                    </div>
                    <div class="col-7 px-2 px-xl-4"></div>
                  </div>


                  <div class="row">
                    <div class="col-5 px-2 px-xl-4">
            <div class="input-group hours_textbox">
              <fieldset>
                <legend>Hours</legend>
              
                <div class="input-group-prepend float-left col-4 p-0">
                  <span class="input-group-text bg-white" style="padding: 4px 5px;">
                    <img class="rep_time_icon" :class="clockIconPositionClass" src="@/assets/manager/repetition_time.png" />
                  </span>
                </div>
                <input 
                  type="number" 
                  step="0.1" 
                  min="0" 
                  class="form-control float-left col-7 p-0 text-muted text-right pr-2" 
                  placeholder="" 
                  v-validate="'required'" 
                  name="timeOnTask" 
                  v-model="timeOnTask" 
                  @input.prevent="checkTimeOnTaskInput" 
                  @input.blur="checkfloatCount" 
                  style="margin-top: -6px !important; text-align: left !important;  padding-left: 50px !important;" />
              </fieldset>

            </div>
                    </div>
                    <div class="col-4 px-2 px-xl-4">
                      &nbsp;
                    </div>
                    <div class="col-3 px-2 px-xl-4 text-center" >
                      <a class="btn btn-primary rounded-pill border-0 text-white approve_btn d-block" @click="onSubmit()" :class="{disabled: submitDone}">Submit</a>
                      <a class="mr-2 d-block" @click="hide()">Close</a>
                    </div>
                  </div>
                  <div class="row align-items-end mb-4" style="margin-top: 0px;">
                    <div class="col-5 px-2 px-xl-4">
                      <div class="validate-warning-msg text-left" v-if="verrors.first('timeOnTask')">Hours is required</div>
                    </div>
                    <div class="col-7 px-2 px-xl-4"></div>
                  </div>

                  <div class="row align-items-end" style="margin-top: 10px;  padding-right: 5px !important;">
                    <div class="col-10 pr-0 col-xl-11 pr-xl-1" style="padding-left: 25px !important;">
                      <textarea name="comments" rows="3" placeholder="Give yourself credit for work and time that are NOT on your task list. Describe the work done." class="form-control text-muted" maxLength="180" v-model="comments" v-validate="'required'" ></textarea>
                    </div>
                    <div class="col-2 pl-0 pr-3 col-xl-1 px-xl-0 text-right text-muted" style=" padding-right: 25px !important;">
                      {{ this.comments.length }}/{{ this.characterLimit }}
                    </div>
                  </div>
                  <div class="row align-items-end mb-4">
                    <div class="col-5 px-2 px-xl-4">
                      <div class="validate-warning-msg text-left" v-if="verrors.first('comments')">Comment is required</div>
                    </div>
                    <div class="col-7 px-2 px-xl-4"></div>
                  </div>

                </div>
              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { formatRepTime, calcRepTime, formatRepDate, timeOnTaskInput } from '@/components/shared/utils.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['isModalVisible', 'menteeId', 'clockIconPositionClass', 'type'],
  data() {
    return {
      comments: '',
      timeOnTask: '',
      characterLimit: 180,
      feedback: '',
      showWait: false,
      taskListId: '',
      tasklist_options: [], 
      submitDone: false,

    }
  },
  computed: {

  },
  methods: {
    checkTimeOnTaskInput(ev) {
      let newValue = timeOnTaskInput(ev);

      if (newValue != '') {
        this.timeOnTask = newValue;
      }
    },
    checkfloatCount() {
      var decimalCount = this.timeOnTask.toString().split(".")[1].length;
      if(decimalCount > 1) {
        alert("Time should contain single decimal value");
        var val = this.timeOnTask;
        this.timeOnTask = parseFloat(val).toFixed(1);
        return false;
      }
    },
    hide() {
      this.$emit('closeTaskListOtherTasksModal');
    },
    getTaskLists(menteeId) {
      this.menteeId = menteeId;
      this.$validator.reset();
      this.timeOnTask = '';
      this.taskListId = '';
      this.comments = '';
      const params = { mentee_id: this.menteeId, account_id: this.$store.state.user_accountid }
      axios.get("/desktop/v2/get_current_step_tasklist", {
         params: params
      })
      .then(response => {
        this.tasklist_options = [
            { value: '', text: 'Select TaskLists' },
        ];       
        for (var i = 0; i <= response.data.length; i++) {
            var yoptions = { value: response.data[i].value, text: response.data[i].text };
            this.tasklist_options.push(yoptions);
        }
      })
      .catch(e => {
      })
      setTimeout(() => {
        let element = document.getElementById('groupModal3');    
        element.scrollIntoView(true);
      }, 2000); 

    },
    doValidateAddRep() {
      var flag = 0;
      if((this.timeOnTask == '0.0') || (this.timeOnTask == 0)) {
          alert("Time should be greater than zero");
          flag = 1;
      }
      return flag;
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
          if(!result){
              return;
          }
          var flag = this.doValidateAddRep();
          if(flag == 0) {
            var decimalDigits = this.timeOnTask.toString().split(".")[1];
            if(decimalDigits) {
              var decimalCount = decimalDigits.length;
              if(decimalCount > 1) {
                alert("Time should contain single decimal value");
                var val = this.timeOnTask;
                this.timeOnTask = parseFloat(val).toFixed(1);
              }
            }
            this.saveTasks();
          }
      }).catch(() => {
          // catches the error;
      });
    },
    saveTasks: function() {
      this.submitDone = true;
      this.showWait = true;

      var url = '/desktop/manager/othertasks/insert';
      var roles = this.$store.state.roles;
      if((roles.indexOf('ROLE_MENTEE') > -1) || (roles.indexOf('ROLE_APPRENTICE') > -1)) {
        url = '/desktop/mentee/othertasks/insert';
      }
        axios(url,
        {
          method: 'POST',
          data: {
            description: this.comments,
            time_on_task: calcRepTime(this.timeOnTask),
            rating: this.feedback,
            mentee_id: this.menteeId,
            tasklist_id: this.taskListId,
            account_id: this.$store.state.user_accountid,
          },
        })
        .then(() => {
          this.submitDone = false;
          this.$validator.reset();
          this.timeOnTask = '';
          this.taskListId = '';
          this.comments = '';
          this.hide();
        })
        .catch((error) => {
          // console.log(error)
          this.submitDone = false;
          this.submit_form_errors = error.response.data.message;
        });

    },

  },
  components: {

  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}

.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
.hours_overtext {
  position: absolute;
  top: -22%;
  left: 20%;
  z-index: 4;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
.hours_textbox span {
  border: 0;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}
.hours_textbox input {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 0;
}
@media (max-width: 1199.98px) {
  .hours_textbox span {
    padding: 6px;
  }
}
.clock-icon-position-middle {
  position: absolute;
  transform: translateX(-50%);
  left: 0;
  background-color: white;
}
.rep_reply_icon {
  transform: scaleY(-1);
}
fieldset {
  border: 1px solid #ced4da;
  border-radius: 10px;
}
legend {
  color: #002F42;
  font-size: 14px;
  padding-left: 5px;
  margin-bottom: 1px;
  width: 50px;
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_tasklist_add_othertask_from_progress_modal.vue